import { Box, CircularProgress, Alert } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { health_api } from "../../../Config";
import { getHDFCPolicydata } from "../../../Redux/Health/action";
import PdfPopup from "../../Components/PopUp/PdfPopUp/PdfViewer";
import { hdfcVerifyKyc } from "../../api/Kyc"
import { decryptData } from "../../../Framework/Utils/decrypt.js"
import {encryptData} from "../../../Framework/Utils/encrypt.js"



const HDFCKycPage = () => {
  const proposalData = useSelector((e) => e?.healthReducer?.healthproposalData);
  const dispatch = useDispatch();
  const txnID = useSelector((e) => e?.healthReducer?.generatedHDFCTxnId);
  let [params] = useSearchParams();
  const [checkSumData, setCheckSumData] = useState({});
  const [send, setSend] = useState(false);
  const [loading, setLoading] = useState(true);
  const [res, setRes] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [pdfBytes, setPdfBytes] = useState(null);
  const [responseText, setResponseText] = useState("");


  useEffect(() => {
    const fetchProposalData = async () => {
      let pehchanId = params?.get("kyc_id");
      let Adress1 = params?.get("Address1");
      let Address2 = params?.get("Address2");
      let permAddress1 = params?.get("PermAddress1");
      let permAddress2 = params?.get("permAdress2");
     
      let Pincode = params?.get("Pincode");
      console.log(pehchanId, "dsnmndb");
      let hdfctransationId = params?.get("txnId");
      let status = params?.get("status")
      let name=params?.get("name")
      let dob=params?.get("dob")


      let data = {
        ...proposalData,
        pehchanId: pehchanId,
        hdfcTraxnId: txnID,
        provider: "HDFC",
        HDFCData: {
          name,
          dob,
          Adress1,
          Address2,
          permAddress1,
          permAddress2,
         
          Pincode
        }
      };

      try {
        if (params.get("status") === "approved") {
          data = {
            ...data,
            hdfctransationId,
            status
          }

          const hdfcVerify = await hdfcVerifyKyc(data);
          console.log("hdfcVerifyKyc", hdfcVerify);
          const hdfcVerifyResponse = hdfcVerify?.body
          const parsedResponse = JSON.parse(hdfcVerifyResponse);
        


          data = {
            ...data,
            HDFCData: {
              ...data.HDFCData, // Preserve existing data
              name:parsedResponse?.data?.name ?? data?.HDFCData?.name,
              Adress1: parsedResponse?.data?.correspondenceAddress1 ?? data?.HDFCData?.Adress1,
              Address2: parsedResponse?.data?.correspondenceAddress2 ?? data?.HDFCData?.Address2,
              permAddress1: parsedResponse?.data?.permanentAddress1 ?? data?.HDFCData?.permAddress1,
              permAddress2: parsedResponse?.data?.permanentAddress2 ?? data?.HDFCData?.permAddress2,
              dob: parsedResponse?.data?.dob ?? data?.HDFCData?.dob,
              Pincode: parsedResponse?.data?.permanentPincode ?? data?.HDFCData?.Pincode,
            },
          }
        }
 let encrypted=encryptData(data);
          setResponseText("Submitting Proposal")
          const proposalResponse = await axios.post(
            `${health_api}/insurance/v1/health/policy/proposal`,
            
            { payload:encrypted}
          );
      
            let resObj = decryptData(proposalResponse.data)

          console.log(resObj, "parseresObj in line 240");
          console.log(resObj.body, "parseresObj");

          setRes(resObj);
          if (resObj.error) {
            setLoading(true)
            setResponseText(resObj?.error?.Error)
          }
          setRes(resObj);
          if (resObj.body.StatusCode === 200) {
            let proposalNumber =
              resObj?.body?.Policy_Details?.ProposalNumber || null;
            
            setResponseText("Proposal Sucess Fetching CIS Document")
            const encryptCIS=encryptData({
              TransactionID: resObj?.body?.TransactionID,
              Req_Policy_Document: {
                Proposal_Number: proposalNumber,
              }
            })
            const fetchCISDocument = async () => {
              const responseData = await axios.post(
                "https://1umwbwg2b7.execute-api.ap-south-1.amazonaws.com/Prod/insurance/v1/health/policy/getcisdocument",

                  //  "http://localhost:8083/insurance/v1/health/getcisdocument",
                {payload:encryptCIS},
                
              );
              const depcryptedCis=decryptData(responseData.data)
              console.log(responseData, "responseData in line 256");
              console.log(depcryptedCis, "responseData.data in line 257");
              const responseBody = depcryptedCis;
              console.log(responseBody, "responseBody in line 260");
              if (responseBody.status === 500) {
                setResponseText("CIS Failed ")
              }
              setPdfBytes(responseBody.Resp_Policy_Document.PDF_BYTES);
              setShowPopup(true);
            };
            await fetchCISDocument();
          }
        
      } catch (err) {
        console.log("checksum error", err);
        if (err.status === 504) {
          setResponseText("Proposal Submission Failed Due to TimeOut Please Refresh and Try Again ")
        }
        
      }
    };

    fetchProposalData();
  }, [params,proposalData,txnID]);


  //form submit logic
  if (send || res?.StatusCode === 200) {
    setTimeout(() => {
      document.getElementById("form").submit();
    }, 1000);
  }


  const handlePaymentProceed = () => {
    setShowPopup(false);
    setLoading(true);

    const proposalNumber = res?.body?.Policy_Details?.ProposalNumber;

    const totalpremium = res?.body?.Policy_Details?.TotalPremium;
    const netPremium = res?.body?.Policy_Details?.NetPremium;
    let successUrl = `https://main.dy3gwnxriq0bt.amplifyapp.com/health/thank_you`;

    let failureUrl =
      "https://main.dy3gwnxriq0bt.amplifyapp.com/health/thank_you";
    const currentDate = new Date().toISOString().slice(2, 10).replace(/-/g, "");
    let randomDigits = Math.floor(Math.random() * 100000)
      .toString()
      .padStart(5, "0");
    const trnsno = `1127${currentDate}${randomDigits}`;

    axios
      .get(
        `https://heapp21.hdfcergo.com/UAT/PaymentUtilitiesService/PaymentUtilities.asmx/GenerateRequestChecksum?TransactionNo=${trnsno}&TotalAmount=${totalpremium}&AppID=${"10295"}&SubscriptionID=S000000333&SuccessUrl=${successUrl}&FailureUrl=${failureUrl}&Source=POST`
      )
      .then(async (res) => {
        let checksum = res.data.split(">")[2]?.split("<")[0];
        let resDataToRedux = {
          proposalNumber: proposalNumber,
          totalpremium: totalpremium,
          netPremium: netPremium,
          hdfcCheckSum: checksum,
          intrumentno: trnsno,
          txnID: txnID,
          provider: "HDFC",
        };
        dispatch(getHDFCPolicydata(resDataToRedux));

        console.log(
          resDataToRedux,
          "getHDFCPolicydata(resDataToRedux)getHDFCPolicydata(resDataToRedux)"
        );

        let dataOfCheckSum = {
          trnsno: trnsno,
          amt: `${totalpremium}`,
          appid: "10295",
          subid: "S000000333",
          surl: `${successUrl}`,
          furl: `${failureUrl}`,
          src: "POST",
          chksum: `${checksum}`,
        };
        setCheckSumData(dataOfCheckSum);
        setSend(true);
        setLoading(false);
      });
  };

  return (
    <div>
      {loading ? (
        <Box
          sx={{
            height: "600px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <CircularProgress />
          <Box
            sx={{
              height: "70px",
              maxWidth: "500px",
              position: "absolute",
              bottom: 20,
              right: 20,
            }}
          >
            {responseText && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {responseText}
              </Alert>
            )}
          </Box>

          {showPopup && (
            <PdfPopup
              open={showPopup}
              setOpen={setShowPopup}
              base64Pdf={pdfBytes}
              onConsent={handlePaymentProceed}
            />
          )}
        </Box>
      ) : (
        <>
          <Box
            sx={{
              height: "70px",
              maxWidth: "500px",
              position: "absolute",
              bottom: 20,
              right: 20,

            }}
          >
            {responseText && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {responseText}
              </Alert>
            )}
          </Box>

          <form
            action="https://heapp21.hdfcergo.com/UAT/OnlineProducts/CCPGISUBSCRIBER/MakePayment.aspx"
            name="PAYMENTFORM"
            method="POST"
            _lpchecked="1"
            id="form"
          >
            <div>
              <input type="hidden" name="trnsno" value={checkSumData.trnsno} />
              <input type="hidden" name="amt" value={checkSumData.amt} />
              <input type="hidden" name="appid" value={checkSumData.appid} />
              <input type="hidden" name="subid" value={checkSumData.subid} />
              <input type="hidden" name="surl" value={checkSumData.surl} />
              <input type="hidden" name="furl" value={checkSumData.furl} />
              <input type="hidden" name="src" value="POST" />
              <input type="hidden" name="chksum" value={checkSumData.chksum} />
              <input type="hidden" name="Additionalinfo1" value="" />
              <input type="hidden" value="submit" />
            </div>
          </form>

        </>
      )}
    </div>
  );
};

export default HDFCKycPage;
